import defaultStyles from "fond/draw/defaultStyles";
import { MapboxStyleLayer } from "fond/types";

// Matches the Parcel layer's regular (non-editing) styling: FillColor: "purple", FillOpacity: 0.25.
const PARCEL_COLOR = "purple";
const PARCEL_FILL_OPACITY = 0.25;

const modifiedDefaults: MapboxStyleLayer[] = defaultStyles.map((style) => {
  if (style.id === "gl-draw-polygon-fill") {
    return {
      ...style,
      paint: {
        ...style.paint,
        "fill-color": PARCEL_COLOR,
        "fill-outline-color": PARCEL_COLOR,
        "fill-opacity": PARCEL_FILL_OPACITY,
      },
    } as mapboxgl.FillLayer;
  }

  if (style.id === "gl-draw-polygon-stroke-inactive") {
    return {
      ...style,
      paint: {
        ...style.paint,
        "line-color": "#9a76fb",
        "line-width": 1,
      },
    } as mapboxgl.LineLayer;
  }

  return style;
});

const styles: MapboxStyleLayer[] = [
  ...modifiedDefaults,
  // Add a custom hover style
  {
    id: "gl-draw-point-hover-active",
    type: "circle",
    filter: ["all", ["==", "$type", "Point"], ["==", "meta", "feature"], ["!=", "mode", "static"]],
    paint: {
      "circle-color": "#BBD5ED",
      "circle-radius": ["interpolate", ["linear"], ["zoom"], 10, 0, 18, 5],
      "circle-opacity": ["case", ["==", ["get", "user_meta:hover"], "true"], 1, 0],
      "circle-stroke-width": ["case", ["==", ["get", "user_meta:hover"], "true"], 2, 0],
      "circle-stroke-color": "#8BA2B7",
    },
  },
];

export default styles;
